<template>
  <div id="viewHotNews" class="container">
    <div class="bread">
      <el-row :gutter="20">
        <el-col :span="16">
          <div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/newsCenter' }">宝枫林咨询</el-breadcrumb-item>
              <el-breadcrumb-item>详情</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </el-col>
        <el-col :span="8">
          <div>
            <span style="color:#333333;font-size:18px">更多热文</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div v-if="data">
      <el-row :gutter="15">
        <el-col :span="16">
          <div style="background-color:#fff;padding:30px 20px;">
            <div style="padding:20px;color:#333333;font-size:20px;padding:20px 0;">{{data.title}}</div>
            <div v-html="data.content"></div>
          </div>
        </el-col>
        <el-col :span="8">
          <div>
            <div v-for="(item,index) of right" :key="index" class="item">
              <router-link :to="'/viewHotNews/'+item.id">
                <div style="color:#333333;margin-bottom:10px">{{item.title}}</div>
                <div style="color:#999999;line-height:1.5em">{{item.abstract}}</div>
              </router-link>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      //
      data: null,
      right: null
    };
  },
  created() {
    //
    this.initData();
  },
  methods: {
    initData() {
      this.axios
        .get(this.serve + "/news_detail", {
          params: {
            id: this.$route.params.id
          }
        })
        .then(res => {
          this.data = res.data.data;
        });

      this.axios.get(this.serve + "/more_news").then(res => {
        this.right = res.data.data;
      });
    }
  }
};
</script>
<style lang="scss">
#viewHotNews {
  padding-bottom: 30px;
  .item {
    border-bottom: 1px solid #ddd;
    padding: 10px;
    background-color: #fff;
    height: 135px;
    overflow: hidden;
  }
  .item:hover {
    background-color: #f7f9fa;
  }
}
</style>